import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useEditBookMutation,
  useGetSingleBookQuery,
} from "../../features/books/bookApi";

const initialState = {
  name: "",
  author: "",
  thumbnail: "",
  price: null,
  rating: null,
  featured: false,
};

export default function EditBookForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState(initialState);
  const [editBook, { isError, isSuccess }] = useEditBookMutation();
  const {
    data: book,
    isError: isSingleBookError,
    isSuccess: isSingleBookSuccess,
    isLoading: isSingleBookLoading,
  } = useGetSingleBookQuery(id);

  useEffect(() => {
    if (isSingleBookSuccess) {
      const { name, author, thumbnail, price, rating, featured } = book;

      setFormData({
        name,
        author,
        thumbnail,
        price,
        rating,
        featured,
      });
    }
  }, [book, isSingleBookSuccess]);

  useEffect(() => {
    if (isSuccess) {
      setFormData(initialState);
      navigate("/");
    }
  }, [isSuccess, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    editBook({ id: id, book: formData });
  };

  return (
    <>
      {isSingleBookLoading ? (
        <div>Loading...</div>
      ) : isSingleBookError ? (
        <div>Failed to fetch single video data</div>
      ) : (
        <form className="book-form" onSubmit={handleSubmit}>
          <div className="space-y-2">
            <label htmlFor="lws-bookName">Book Name</label>
            <input
              required
              className="text-input"
              type="text"
              id="lws-bookName"
              name="name"
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              value={formData.name}
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="lws-author">Author</label>
            <input
              required
              className="text-input"
              type="text"
              id="lws-author"
              name="author"
              onChange={(e) =>
                setFormData({ ...formData, author: e.target.value })
              }
              value={formData.author}
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="lws-thumbnail">Image Url</label>
            <input
              required
              className="text-input"
              type="text"
              id="lws-thumbnail"
              name="thumbnail"
              onChange={(e) =>
                setFormData({ ...formData, thumbnail: e.target.value })
              }
              value={formData.thumbnail}
            />
          </div>
          <div className="grid grid-cols-2 gap-8 pb-4">
            <div className="space-y-2">
              <label htmlFor="lws-price">Price</label>
              <input
                required
                className="text-input"
                type="number"
                id="lws-price"
                name="price"
                onChange={(e) =>
                  setFormData({ ...formData, price: e.target.valueAsNumber })
                }
                value={formData.price}
              />
            </div>
            <div className="space-y-2">
              <label htmlFor="lws-rating">Rating</label>
              <input
                required
                className="text-input"
                type="number"
                id="lws-rating"
                name="rating"
                min={1}
                max={5}
                onChange={(e) =>
                  setFormData({ ...formData, rating: e.target.valueAsNumber })
                }
                value={formData.rating}
              />
            </div>
          </div>
          <div className="flex items-center">
            <input
              id="lws-featured"
              type="checkbox"
              name="featured"
              className="w-4 h-4"
              onChange={(e) =>
                setFormData({ ...formData, featured: e.target.checked })
              }
              checked={formData.featured}
            />
            <label htmlFor="lws-featured" className="ml-2 text-sm">
              {" "}
              This is a featured book{" "}
            </label>
          </div>
          <button type="submit" className="submit" id="lws-submit">
            Edit Book
          </button>

          {isError && <div>Failed to edit book</div>}
        </form>
      )}
    </>
  );
}
